import { withHTMLComponent } from '@updater-local/custom-element-v1';
import '@updater-components/dialog';
import '@updater-components/fa-icon';
import styles from './index.css';

const html = `
  <upd-dialog id="modal">
    <div id="modalWrapper">
      <div id="modalHeader"></div>
      <button id="modalCloseBtn">
        <upd-fa-icon name="times" type="light"></upd-fa-icon>
        <span>Close</span>
      </button>

      <div id="modalContent">
        <slot></slot>
      </div>
    </div>
  </upd-dialog>
`;

export default class Modal extends withHTMLComponent(styles, html)() {
  _state = {
    open: false,
  };

  static get observedAttributes() {
    return ['open'];
  }

  static get reflectedAttributes() {
    return [{ name: 'open', boolean: true }];
  }

  constructor() {
    super();
    this._dialog = this.shadowRoot.querySelector('#modal');
    this._closeBtn = this.shadowRoot.querySelector('#modalCloseBtn');
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'open') {
      this.mergeState({ open: this.open });
    }
  }

  connected() {
    this._dialog.addEventListener('close', this._handleDialogClose);
    this._closeBtn.addEventListener('click', this._handleClickClose);
  }

  disconnected() {
    this._dialog.removeEventListener('close', this._handleDialogClose);
    this._closeBtn.removeEventListener('click', this._handleClickClose);
  }

  updated({ _state: { open } }) {
    open ? this._dialog.showModal() : this._dialog.close();
  }

  _handleClickClose = () => {
    this.mergeState({ open: false });
  };

  _handleDialogClose = event => {
    event.stopPropagation();
    this.mergeState({ open: false });

    // TODO: Add bubble and composed to upd-dialog event
    this.dispatchEvent(
      new Event('close', {
        bubbles: true,
        composed: true,
      })
    );
  };
}

customElements.define('upd-moveiq-modal', Modal);
